(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sold-30-days"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-yofeely-sold-30-days]').forEach((notice) => {
    const handle = notice.dataset.productHandle;
    const key = 'yofeelySold30Closed:' + handle;
    try {
      if (sessionStorage.getItem(key)) {
        notice.hidden = true;
      }
    } catch (error) {
      void error;
    }

    notice.querySelector('[data-yofeely-sold-30-days-close]')?.addEventListener('click', () => {
      notice.hidden = true;
      try {
        sessionStorage.setItem(key, '1');
      } catch (error) {
        void error;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yofeely-deferred-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yofeely-deferred-reviews')) {
  class YofeelyDeferredReviews extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.panel = this.closest('[tab-item]');
      if (!this.panel) return;
      this.observer = new MutationObserver(() => this.check());
      this.observer.observe(this.panel, {
        attributes: true,
        attributeFilter: ['tab-selected']
      });
      this.starClick = event => {
        const trigger = event.target.closest('.yotpo-sr-bottom-line-button');
        if (!trigger?.closest('.hdt-product-info__list')) return;
        const tab = document.querySelector(
          'hdt-tab[aria-controls="' + CSS.escape(this.panel.parentElement.id) + '"]'
        );
        const panels = Array.from(this.panel.parentElement.querySelectorAll('[tab-item]'));
        const button = tab?.querySelectorAll('button')[panels.indexOf(this.panel)];
        if (!button) return;
        this.scrollOnLoad = true;
        button.click();
        this.check();
      };
      document.addEventListener('click', this.starClick, true);
      this.check();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timer);
      document.removeEventListener('click', this.starClick, true);
    }
    check() {
      if (!this.panel.hasAttribute('tab-selected')) return;
      if (this.scrollOnLoad) {
        this.scrollOnLoad = false;
        this.panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      if (this.loaded) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.loaded = true;
      this.append(template.content.cloneNode(true));
      template.remove();
      this.initialize(0);
    }
    initialize(attempt) {
      if (!this.isConnected) return;
      if (typeof window.yotpo?.initWidgets === 'function') {
        window.yotpo.initWidgets();
        return;
      }
      if (attempt < 30) {
        this.timer = setTimeout(() => this.initialize(attempt + 1), 1000);
      }
    }
  }
  customElements.define('yofeely-deferred-reviews', YofeelyDeferredReviews);
}
  } catch(e) { console.error(e); }
})();

})();
